import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useFormik } from "formik";
import { SUPER_ADMIN_LOGIN_URL } from "../../api/url";

import { adminLogo } from "../../assets/img/image";
import { Input, PasswordInput, Button } from "../../components/ui";
import { toast } from "react-toastify";
import { useAppMutation } from "../../api/fetchClient";
import { strings } from "../../strings/strings";

const Login = () => {
  const navigate = useNavigate();
  const loginMutation = useAppMutation();
  const formik = useFormik({
    initialValues: {
      userName: "",
      password: "",
      rememberMe: false,
    },

    onSubmit: async (values) => {
      try {
        const payload = {
          username: values.userName,
          password: values.password,
        };

        const res = await loginMutation.mutateAsync({
          url: SUPER_ADMIN_LOGIN_URL,
          method: "POST",
          data: payload,
        });

        if (!res?.success) {
          toast.error(strings.invalidcredentials);
          return;
        }

        toast.success(res.message);
        if (values.rememberMe) {
          localStorage.setItem(
            strings.lastlogin,
            JSON.stringify({
              userName: values.userName,
              password: values.password,
              rememberMe: true,
              expiry: Date.now() + 14 * 24 * 60 * 60 * 1000,
            }),
          );
        } else {
          localStorage.removeItem(strings.lastlogin);
        }

        const user = res.results;

        navigate("/verify-otp", {
          replace: true,
          state: {
            role: user.role,
            userId: user.userId,
            otpReference: user.otpReference,
          },
        });
      } catch (error) {
        toast.error(error?.message);
      }
    },
  });

useEffect(() => {
  const lastLoginData = localStorage.getItem(strings.lastlogin);

  if (lastLoginData) {
    try {
      const lastLogin = JSON.parse(lastLoginData);
      if (Date.now() < lastLogin.expiry) {
        formik.setFieldValue(strings.userName, lastLogin.userName);
              formik.setFieldValue(strings.password, lastLogin.password);
        formik.setFieldValue(strings.remember_me, lastLogin.rememberMe || false);
      } else {

        localStorage.removeItem(strings.lastlogin);
      }
    } catch (error) {
      localStorage.removeItem(strings.lastlogin);
    }
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);
  const isFormFilled = formik.values.userName.trim() !== "" && formik.values.password.trim() !== "";

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <div className="w-full max-w-sm bg-white/20 backdrop-blur-2xl border border-white/40 rounded-3xl shadow-[0_20px_80px_rgba(0,0,0,0.15)] p-8 bg-gradient-to-br from-white/40 to-white/10 transition-all">
        <div className="flex justify-center">
          <div className="w-20 h-20 flex items-center justify-center">
            <img src={adminLogo} alt="" />
          </div>
        </div>

        <div className="text-center mb-5">
          <p className="text-base text-secondary">{strings.pleaselogintocontinue}</p>
        </div>

        <form onSubmit={formik.handleSubmit} className="space-y-6">
          <Input
            type="text"
            name={strings.userName}
            placeholder={strings.userName2}
            value={formik.values.userName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.userName}
            touched={formik.touched.userName}
            className="font-bold"
          />

          <PasswordInput
            name={strings.password}
            placeholder={strings.password2}
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.password}
            touched={formik.touched.password}
            className="font-bold"
          />

          <div className="flex items-center">
            <input
              id={strings.remember_me2}
              name={strings.remember_me}
              type="checkbox"
              checked={formik.values.rememberMe}
              onChange={formik.handleChange}
              className="h-4 w-4 text-secondary-500 rounded focus:ring-secondary-500/20"
            />
            <label htmlFor={strings.remember_me2} className="ml-2 text-sm text-secondary">
              {strings.rememberme}
            </label>
          </div>

          <Button
            type="submit"
            isLoading={loginMutation.isPending}
            disabled={!isFormFilled || loginMutation.isPending}
            className={`w-full py-3 rounded-xl font-semibold shadow-xl
    transition tracking-wide
    ${isFormFilled ? "bg-primary text-white hover:bg-opacity-90" : "bg-primary text-gray-500 cursor-not-allowed"}
  `}
          >
            {strings.sendotp}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
